import { TextControl } from "./TextControl";
import { Controller } from "./Controller";
import { app } from "../Frame/App";

export class NumberControl extends TextControl {

    constructor(protected input: HTMLInputElement, controller: Controller, field: string) {
        super(input, controller, field);
    }

    updateControlFromModel() {
        let value = this.getModelValue();
        this.input.value = app.isNullOrUndefined(value) ? "" : value;
    }

    updateModelFromControl() {
        this.setModelValue(app.anyToInt(this.input.value, 0));
    }
}
